import React from 'react';
import {
  Edit,
  SimpleForm,
  TextInput,
  NumberInput,
  SelectInput,
  ReferenceInput,
  DateInput,
  ArrayInput,
  SimpleFormIterator,
  required,
  TopToolbar,
  DeleteButton,
} from 'react-admin';
import { Box, Typography } from '@mui/material';

const EditActions = () => (
  <TopToolbar>
    <DeleteButton />
  </TopToolbar>
);

export const BillEdit = () => (
  <Edit actions={<EditActions />}>
    <SimpleForm>
      <Typography variant="h6" gutterBottom>
        Basic Information
      </Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 2, mb: 2 }}>
        <TextInput source="billNumber" label="Bill Number" validate={required()} />
        <TextInput source="title" validate={required()} />
        <ReferenceInput source="customerId" reference="customers">
          <SelectInput optionText="name" validate={required()} />
        </ReferenceInput>
        <SelectInput 
          source="status" 
          label="Status"
          choices={[
            { id: 'draft', name: 'Draft' },
            { id: 'sent', name: 'Sent' },
            { id: 'approved', name: 'Approved' },
            { id: 'rejected', name: 'Rejected' },
            { id: 'expired', name: 'Expired' },
          ]}
          validate={required()}
        />
        <DateInput 
          source="validUntil" 
          label="Valid Until" 
          validate={required()} 
          parse={(value) => value ? new Date(value + 'T00:00:00').toISOString() : null}
          format={(value) => value ? value.split('T')[0] : ''}
        />
      </Box>

      <Typography variant="h6" gutterBottom>
        Line Items
      </Typography>
      <ArrayInput source="lineItems">
        <SimpleFormIterator inline>
          <TextInput source="description" label="Description" validate={required()} />
          <NumberInput source="quantity" label="Quantity" validate={required()} />
          <NumberInput source="unitPrice" label="Unit Price" validate={required()} />
          <NumberInput source="amount" label="Amount" disabled />
        </SimpleFormIterator>
      </ArrayInput>

      <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
        Financial Details
      </Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 2, mb: 2 }}>
        <NumberInput source="subtotal" label="Subtotal" disabled />
        <NumberInput source="taxRate" label="Tax Rate (%)" />
        <NumberInput source="taxAmount" label="Tax Amount" disabled />
        <NumberInput source="totalAmount" label="Total Amount" disabled />
      </Box>

      <Typography variant="h6" gutterBottom>
        Additional Information
      </Typography>
      <TextInput source="notes" multiline rows={3} fullWidth />
      <TextInput source="terms" multiline rows={2} fullWidth />
    </SimpleForm>
  </Edit>
);